import memoize from '@emotion/memoize'
import DOMPurify from 'dompurify'

/**
 * Check if value is number
 *
 * @param  {[type]}  n
 * @return {Boolean}
 */
export function isNumeric(n) {
  return !Number.isNaN(parseFloat(n)) && Number.isFinite(n)
}

/**
 * Santizes error messages for XSS potential vulnerabilities
 * @param str String to sanitize
 * @returns {string}
 */
export const sanitize = memoize((str) => DOMPurify.sanitize(str))

/**
 * Get error message from api response error
 * @param err Error from response
 * @param fallbackMessage Fallback message if there is no error response
 * @returns {string}
 */
export function messageFromResponseError(err, fallbackMessage = '') {
  return err &&
    err.response &&
    err.response.data &&
    typeof err.response.data === 'string'
    ? err.response.data
    : fallbackMessage
}

export function scrollToTopOfResults(wrapperRef) {
  const bodyRect = document.body.getBoundingClientRect()
  const elementRect = wrapperRef.current.getBoundingClientRect()

  window.scrollTo({
    top: elementRect.top - bodyRect.top,
    behavior: 'smooth'
  })
}
